import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { list, reset, filter, sort } from '../../actions/OneWayInterview/list';
import {handleListUpdate, pagination, renderLinks} from "../../utils/entityList";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import Moment from 'react-moment';
import filtersStorage from '../../utils/filtersStorage';
import FilterForm from "./FilterForm";
import {SortableTableCells} from "../../utils/filterForm";
import IsGranted from "../IsGranted";
import Rating from 'material-ui-rating'
import TableFooter from "@material-ui/core/TableFooter";
import {getRoutePage} from "../../utils/routes";
import FlashMessages from "../../views/Components/FlashMessages";

const defaultFilters = {
  'completedAt__exists__': true,
};

class OneWayInterviewList extends Component {
  static propTypes = {
    retrieved: PropTypes.object,
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string,
    eventSource: PropTypes.instanceOf(EventSource),
    list: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    filter: PropTypes.func.isRequired,
    filtersData: PropTypes.object,
    sort: PropTypes.func.isRequired,
    sortData: PropTypes.object,
  };

  componentDidMount() {
    const storageName = 'company_one_way_interview';
    this.props.filter(filtersStorage.get(storageName, defaultFilters));
    this.props.sort(filtersStorage.getSort(storageName));
  }

  componentDidUpdate(prevProps) {
    handleListUpdate('one_way_interviews', this.props, prevProps);
  }

  componentWillUnmount() {
    this.props.reset(this.props.eventSource);
  }

  render() {
    return (
      <div>
        <FlashMessages location={this.props.location} />
        {this.props.loading && (
          <div className="alert alert-info">Loading...</div>
        )}
        {this.props.error && (
          <div className="alert alert-danger">{this.props.error}</div>
        )}

        <FilterForm
          defaultValues={defaultFilters}
          initialValues={this.props.filtersData}
          onSubmit={this.props.filter}
          resetFilter={this.props.filterReset}
          parentLoading={this.props.loading}
        />

        <div style={{'overflowX': 'auto'}}>
          <Table className="table table-responsive table-striped table-hover one-way-interview mb-0">
            <TableHead>
              <TableRow>
                <SortableTableCells sort={this.props.sort} sortData={this.props.sortData} fields={{
                  'id': 'ID',
                  'companyCandidate.firstName': 'Candidate',
                  'request.title': 'On Demand Interview',
                  'totalAverageRating': 'Average Rating',
                  'correctKnockoutAnswersQuantity': 'Screening Results',
                }} />
                <TableCell>Duration</TableCell>
                <SortableTableCells sort={this.props.sort} sortData={this.props.sortData} fields={{
                  'invitation.interviewStatus': 'Progress',
                  'invitation.createdAt': 'Invitation Sent At',
                  'completedAt': 'Completed At',
                }} />
                <TableCell>View</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props.retrieved &&
                this.props.retrieved['hydra:member'].map(item => (
                  <TableRow key={item['@id']}>
                    <TableCell scope="row" className="align-middle">
                      {renderLinks('on-demand-interviews', item, (oneWayInterview) => oneWayInterview['id'], true)}
                    </TableCell>
                    <TableCell className="align-middle">{item.companyCandidate.firstName} {item.companyCandidate.lastName}</TableCell>
                    <TableCell className="align-middle">{item.request.title}</TableCell>
                    <TableCell className="reviews-list-rating-container" style={{minWidth: 222}}>
                      {item['totalAverageRating'] && (
                        <div>
                          <Rating
                            value={parseFloat(item['totalAverageRating'])}
                            max={5}
                            className="total-interview-rating"
                            readOnly={true}
                          />
                          <span className="total-interview-rating-info"> - {item['totalAverageRating']}</span>
                        </div>
                      )}
                    </TableCell>
                    <TableCell className="align-middle">{item.correctKnockoutAnswersQuantity}/{item.request.totalKnockoutQuestions}</TableCell>
                    <TableCell className="align-middle">{item.totalDuration ? item.totalDuration : '00:00'}</TableCell>
                    <TableCell className="align-middle" style={{textTransform: 'capitalize'}}>
                      {item['invitation'] && item['invitation']["interviewStatus"] ? item['invitation']["interviewStatus"].replace('_', ' ') : ''}
                      {item['invitation'] && (
                        <div className="progress-wrapper" style={{borderColor: item['invitation']['progressBarColor']}}>
                          <div className="progress-bar" style={{width: item['invitation']['progressBarPercents'] + '%', backgroundColor: item['invitation']['progressBarColor']}} />
                          <div className={`progress-percents ${item['invitation']['progressBarPercents'] === 100 ? 'full' : ''} ${item['invitation']['progressBarColor']}`}>{ item['invitation']['progressBarPercents'] }%</div>
                        </div>
                      )}
                    </TableCell>
                    <TableCell className="align-middle">{item['invitation'] ? <Moment format={Moment.timeFormat}>{item['invitation']['createdAt']}</Moment>: 'Not sent'}</TableCell>
                    <TableCell className="align-middle">{item['completedAt'] ? <Moment format={Moment.timeFormat}>{item['completedAt']}</Moment> : 'Not completed'}</TableCell>
                    <TableCell className="align-middle">
                      <IsGranted action='show' object={item}>
                      <Link to={`show/${encodeURIComponent(item['@id'])}`}>
                        <span className="fa fa-eye" aria-hidden="true" />
                        <span className="sr-only">Show</span>
                      </Link>
                      </IsGranted>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>

        <Table className="table table-responsive no-border">
          <TableFooter>
            <TableRow>
              {pagination(this.props.retrieved, getRoutePage(this.props.match))}
            </TableRow>
          </TableFooter>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    retrieved,
    loading,
    error,
    eventSource,
    filtersData,
    sortData,
  } = state.onewayinterview.list;
  return { retrieved, loading, error, eventSource, filtersData, sortData };
};

const mapDispatchToProps = dispatch => ({
  list: page => dispatch(list(page)),
  reset: eventSource => dispatch(reset(eventSource)),
  filter: (filtersData) => dispatch(filter(filtersData)),
  filterReset: () => dispatch(filter(defaultFilters)),
  sort: (sortData) => dispatch(sort(sortData)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OneWayInterviewList);
